module.exports = __webpack_public_path__ + "img/Emergency.d22d7c00.jpg";